import React from 'react';

import {Row, Col } from 'react-bootstrap'

const Title = () => {
    return (
        <Row className="justify-content-md-center">
            <Col md="auto">
                <h1>FALLING WORDS</h1>
            </Col>
        </Row>
    );
}

export default Title;